<template>
  <div>
    <Head title="Komponenty" />
    <h1 class="mb-8 text-3xl font-bold">Komponenty</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
        <label class="block mt-5 text-gray-700">Typ:</label>
        <select v-model="form.type" class="form-select mt-1 w-full">
          <option :value="null">Vše</option>
          <option v-for="(type, key) in componentTypes" :key="key" :value="key">{{ type }}</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/components/create">
        <span>Vytvořit</span>
        <span class="hidden md:inline">&nbsp;komponentu</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Název</th>
            <th class="pb-4 pt-6 px-6">Cena</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="component in components.data" :key="component.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/components/${component.id}/edit`">
                {{ component.name }}
                <icon v-if="component.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/components/${component.id}/edit`" tabindex="-1">
                {{ $filters.currency(component.price) }}
              </Link>
            </td>
          </tr>
          <tr v-if="components.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">Zatím není vytvořená žádná komponenta</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="components.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    components: Object,
    componentTypes: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        type: this.filters.type,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/components', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
